import React, {useState, setState} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import OfferDescription from './OfferDescription';
import {FaAngleDown} from 'react-icons/fa';
import './Offers.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const Offers = props => {

	const [visibilityDescription, setvisibilityDescription] = useState('description-hidden');
	const [visibilityDescriptionOne, setvisibilityDescriptionOne] = useState(false);

	return(
		<Container>
		<Row>
			<Col className="center title">
				<h2>Oferta</h2>
			</Col>
		</Row>
		<Row>
			<Col>
				<h5 className="offer-subtitle">Produkty papierowe</h5>
			</Col>
		</Row>
		<section className="offers--box offers__paper--box">
			<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-one')}>
				<div className="offers__item--content">
					<img className="offer__icon" src="icons/icon_2_c.svg" alt="" />
					<span>Torebki papierowe</span>
					<FaAngleDown  className="offers__arrow"/>
				</div>
			</div>
			<div className="d-sm-none">
				{visibilityDescription == 'description-visible box-one' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Torebki papierowe"
					description="Wykonujemy torebki fałdowe i klockowe na zamówienie klienta, oparte na torebce standardowej
						lub przygotowujemy projekt nadruku indywidualnego. Realizujemy nadruk do 4 kolorów."
					subTitleOne="OFERUJEMY:"
					subDescriptionOne="<ul><li>torebki fałdowe PÓŁPANORAMA, jedna z fałd bocznych torby zawiera się w okienku PP</li><li>torebki fałdowe Z OKIENKIEM PP</li><li>torebki fałdowe STANDARD, wykonane w całości z papieru</li></ul>"
					subTitleTwo="NASZE PRODUKTY WYKONANE SĄ Z TRZECH RODZAJÓW PAPIERU:"
					subDescriptionTwo="<ul><li>siarczan bielony</li><li>szary prążkowany EKO</li><li>papier linii EcoFresh</li></ul>"
					photo1="photos/faldowa1.jpg"
					photo2="photos/faldowa2.jpg"
					photo3="photos/faldowa3_logoEcoFresh.jpg"
					photo4="photos/faldowa4.jpg"
					/>
				}
			</div>
			<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-two')}>
				<div className="offers__item--content">
					<img className="offer__icon" src="icons/icon_1_c.svg" alt="" />
					<span>Torby papierowe</span>
					<FaAngleDown  className="offers__arrow"/>
				</div>
			</div>
			<div className="d-sm-none">
				{visibilityDescription == 'description-visible box-two' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Torby papierowe"
					description="W naszej ofercie posiadamy najtańsze i najczęściej używane torby papierowe. Dzięki swej wysokiej wytrzymałości znakomicie sprawdzają się w sklepach i marketach – jedna torba papierowa może zastąpić nawet 5 foliowych. Torby w 100% ekologiczne – przyjazne dla środowiska."
					subTitleOne="UCHWYT:"
					subDescriptionOne="Papier pięciokrotnie składany lub płaski w kolorze białym i szarym. Uchwyt wklejany w górną krawędź torby wraz z dodatkowym wzmocnieniem.<br><br>"
					subTitleTwo="WYTRZYMAŁOŚĆ:"
					subDescriptionTwo="Od 3 do 20 kg w zależności od rozmiaru i standardu wykończenia."
					photo1="photos/eko1.jpg"
					/>
				}
			</div>
			<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-three')}>
				<div className="offers__item--content">
					<img className="offer__icon" src="icons/icon_3_c.svg" alt="" />
					<span>Papier pakowy</span>
					<FaAngleDown  className="offers__arrow"/>
				</div>
			</div>
			<div className="d-sm-none">
				{visibilityDescription == 'description-visible box-three' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Papier pakowy"
					description="Oferujemy Państwu papiery pakowe w opcji z nadrukiem standardowym lub indywidualnym. Oferujemy różnego rodzaju papiery:"
					subTitleOne="PAPIER Z LINII ECOFRESH"
					subDescriptionOne="Są to papiery białe i brązowe w gramaturze od 33 g/m2. Papier w połączeniu z zaledwie 7 mikronową folią HDPE tworzy nowoczesne i zarazem ekologiczne opakowanie. Po użyciu, nadaje się w 100% do powtórnego przetworzenia, poprzez łatwe rozdzielenie obu warstw. Idealnie sprawdza się w przemyśle cukierniczym, mięsnym oraz rybnym.<br><br>"
					subTitleTwo="PAPIER NIEBIELONY (BRĄZOWY KRAFT)"
					subDescriptionTwo="Papier o gramaturze od 32g/m2 do 100g/m2, szeroko stosowany jako papier pakowy w piekarnictwie, cukiernictwie. <br><br><span class='bold'>PAPIER SIARCZANOWY (BIELONY)</span><br>Papier o gramaturze od 33 g/m2. Jest to śnieżnobiały papier o wysokiej wytrzymałości mechanicznej, najczęściej stosowany w przemyśle piekarniczo-cukierniczym.<br><br><span class='bold'>PAPIER SILIKONOWY- BAKING</span><br>Jest to papier tłuszczo – szczelny dwu stronnie pokryty warstwą silikonu spożywczego – ten rodzaj papieru stosowany jest głównie w piekarnictwie, służy jako papier do pieczenia (odpieku)."
					photo1="photos/papier.jpg"
					photo2="photos/ekofresh_Niewiescin.jpg"
					photo3="photos/ekofresh_arkusze.jpg"
					photo4="photos/ekofresh_na_roli.jpg"
					/>
				}
			</div>
			<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-four')}>
				<div className="offers__item--content">
					<img className="offer__icon" src="icons/icon_4_c.svg" alt="" />
					<span>Etykiety</span>
					<FaAngleDown  className="offers__arrow"/>
				</div>
			</div>
			<div className="d-sm-none">
				{visibilityDescription == 'description-visible box-four' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Etykiety"
					description="Stanowią doskonały element uzupełniającym woreczki do pakowania pieczywa bez nadruku. Na stanie posiadamy kilkanaście wzorów standardowych. Istnieje możliwość zaprojektowania indywidualnego, wzoru etykiety."
					photo1="photos/etykiety.jpg"
					/>
				}
			</div>
		</section>
		<div className="d-none d-sm-block">
			{visibilityDescription == 'description-visible box-one' &&
				<OfferDescription 
				visibilityDescription={visibilityDescription}
				setvisibilityDescription={setvisibilityDescription}
				title="Torebki papierowe"
				description="Wykonujemy torebki fałdowe i klockowe na zamówienie klienta, oparte na torebce standardowej
					lub przygotowujemy projekt nadruku indywidualnego. Realizujemy nadruk do 4 kolorów."
				subTitleOne="OFERUJEMY:"
				subDescriptionOne="<ul><li>torebki fałdowe PÓŁPANORAMA, jedna z fałd bocznych torby zawiera się w okienku PP</li><li>torebki fałdowe Z OKIENKIEM PP</li><li>torebki fałdowe STANDARD, wykonane w całości z papieru</li></ul>"
				subTitleTwo="NASZE PRODUKTY WYKONANE SĄ Z TRZECH RODZAJÓW PAPIERU:"
				subDescriptionTwo="<ul><li>siarczan bielony</li><li>szary prążkowany EKO</li><li>papier linii EcoFresh</li></ul>"
				photo1="photos/faldowa1.jpg"
				photo2="photos/faldowa2.jpg"
				photo3="photos/faldowa3_logoEcoFresh.jpg"
				photo4="photos/faldowa4.jpg"
				/>
			}
			{visibilityDescription == 'description-visible box-two' &&
				<OfferDescription 
				visibilityDescription={visibilityDescription}
				setvisibilityDescription={setvisibilityDescription}
				title="Torby papierowe"
				description="W naszej ofercie posiadamy najtańsze i najczęściej używane torby papierowe. Dzięki swej wysokiej wytrzymałości znakomicie sprawdzają się w sklepach i marketach – jedna torba papierowa może zastąpić nawet 5 foliowych. Torby w 100% ekologiczne – przyjazne dla środowiska."
				subTitleOne="UCHWYT:"
				subDescriptionOne="Papier pięciokrotnie składany lub płaski w kolorze białym i szarym. Uchwyt wklejany w górną krawędź torby wraz z dodatkowym wzmocnieniem.<br><br>"
				subTitleTwo="WYTRZYMAŁOŚĆ:"
				subDescriptionTwo="Od 3 do 20 kg w zależności od rozmiaru i standardu wykończenia."
				photo1="photos/eko1.jpg"
				/>
			}
			{visibilityDescription == 'description-visible box-three' &&
				<OfferDescription 
				visibilityDescription={visibilityDescription}
				setvisibilityDescription={setvisibilityDescription}
				title="Papier pakowy"
				description="Oferujemy Państwu papiery pakowe w opcji z nadrukiem standardowym lub indywidualnym. Oferujemy różnego rodzaju papiery:"
				subTitleOne="PAPIER Z LINII ECOFRESH"
				subDescriptionOne="Są to papiery białe i brązowe w gramaturze od 33 g/m2. Papier w połączeniu z zaledwie 7 mikronową folią HDPE tworzy nowoczesne i zarazem ekologiczne opakowanie. Po użyciu, nadaje się w 100% do powtórnego przetworzenia, poprzez łatwe rozdzielenie obu warstw. Idealnie sprawdza się w przemyśle cukierniczym, mięsnym oraz rybnym.<br><br>"
				subTitleTwo="PAPIER NIEBIELONY (BRĄZOWY KRAFT)"
				subDescriptionTwo="Papier o gramaturze od 32g/m2 do 100g/m2, szeroko stosowany jako papier pakowy w piekarnictwie, cukiernictwie. <br><br><span class='bold'>PAPIER SIARCZANOWY (BIELONY)</span><br>Papier o gramaturze od 33 g/m2. Jest to śnieżnobiały papier o wysokiej wytrzymałości mechanicznej, najczęściej stosowany w przemyśle piekarniczo-cukierniczym.<br><br><span class='bold'>PAPIER SILIKONOWY- BAKING</span><br>Jest to papier tłuszczo – szczelny dwu stronnie pokryty warstwą silikonu spożywczego – ten rodzaj papieru stosowany jest głównie w piekarnictwie, służy jako papier do pieczenia (odpieku)."
				photo1="photos/papier.jpg"
				photo2="photos/ekofresh_Niewiescin.jpg"
				photo3="photos/ekofresh_arkusze.jpg"
				photo4="photos/ekofresh_na_roli.jpg"
				/>
			}
			{visibilityDescription == 'description-visible box-four' &&
				<OfferDescription 
				visibilityDescription={visibilityDescription}
				setvisibilityDescription={setvisibilityDescription}
				title="Etykiety"
				description="Stanowią doskonały element uzupełniającym woreczki do pakowania pieczywa bez nadruku. Na stanie posiadamy kilkanaście wzorów standardowych. Istnieje możliwość zaprojektowania indywidualnego, wzoru etykiety."
				photo1="photos/etykiety.jpg"
				/>
			}
		</div>

		<Row>
			<Col>
				<h5 className="m-t-5 offer-subtitle">Produkty foliowe</h5>
			</Col>
		</Row>
			<section className="offers--box offers__foil--box">
				<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-five')}>
					<div className="offers__item--content">
						<img className="offer__icon" src="icons/icon_8_c.svg" alt="" />
						<span>Torebki PP/LDPE</span>
						<FaAngleDown  className="offers__arrow"/>
					</div>
				</div>
				<div className="d-sm-none">
					{visibilityDescription == 'description-visible box-five' &&
						<OfferDescription 
						visibilityDescription={visibilityDescription}
						setvisibilityDescription={setvisibilityDescription}
						title="Torebki foliowe"
						description="W naszej ofercie produkcyjnej znajdziecie Państwo torebki wykonane z wysokiej jakości folii polipropylenowej typu PP CAST oraz LDPE. Charakteryzują się one wysoką przejrzystością i doskonałą przepuszczalnością pary wodnej.<br><br>Cechy te gwarantują najlepsze wyeksponowanie pieczywa oraz optymalizację procesu przechowywania na wszystkich etapach od produkcji przez transport do ekspozycji w sklepach. Umożliwia to skuteczne budowanie korzystnego wizerunku firmy oraz obniżenie ilości zwrotów niesprzedanego pieczywa.<br><br>Oferujemy wykonanie projektów na zamówienie klienta, opartego na dużej gamie gotowych wzorów lub wzoru wykonanego pod zamówienie klienta. Realizujemy zamówienia już od 50 tys. sztuk z terminem dostawy do 3 tygodni od dnia zatwierdzenia wzoru projektu nadruku.<br><br>"
						subTitleOne="NAJWAŻNIEJSZE ZALETY NASZYCH WORECZKÓW:"
						subDescriptionOne="<ul><li>projekt w cenie torebki,</li><li>nadruk fleksograficzny do 8 kolorów</li><li>wysoka wydajność pakowania; fałdy zwiększające pojemność torebki,</li><li>wysoka przejrzystość folii podnosząca estetykę zapakowanego pieczywa,</li><li>otwory wentylacyjne umożliwia pakowanie niestudzonego pieczywa.</li><li>perforacja klapki zwiększa estetykę zapakowanego pieczywa.</li></ul><br><br>"
						photo1="photos/pp1.jpg"
						photo2="photos/pp2.jpg"
						photo3="photos/pp3.jpg"
						photo4="photos/pp4.jpg"
						photopp1="pp/pp1.png"
						photopp2="pp/pp2.png"
						photopp3="pp/pp3.png"
						photopp4="pp/pp4.png"
						photopp5="pp/pp5.png"
						/>
					}
				</div>
				<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-six')}>
					<div className="offers__item--content">
						<img className="offer__icon" src="icons/icon_7_c.svg" alt="" />
						<span>Torebki płasko-fałdowe BOPP</span>
						<FaAngleDown  className="offers__arrow"/>
					</div>
				</div>
				<div className="d-sm-none">
					{visibilityDescription == 'description-visible box-six' &&
						<OfferDescription 
						visibilityDescription={visibilityDescription}
						setvisibilityDescription={setvisibilityDescription}
						title="Torebki płaskofałdowe BOPP"
						description="Oferujemy Państwu usługi z zakresu nadruku fleksograficznego do 8 kolorów na folii BOPP. Drukujemy na awersie lub rewersie w zależności od potrzeb. Docinamy i przewijamy folię wg specyfikacji klienta. Zapewniamy kompleksową obsługę od fazy projektu do gotowego opakowania. Oferujemy również fachowe doradztwo i pomoc w redukcji kosztów w trakcie wdrażania nowych oraz już funkcjonujących projektów."
						photo1="photos/BOPP.jpg"
						/>
					}
				</div>
				<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-seven')}>
					<div className="offers__item--content">
						<img className="offer__icon" src="icons/icon_6_c.svg" alt="" />
						<span>Laminaty</span>
						<FaAngleDown  className="offers__arrow"/>
					</div>
				</div>
				<div className="d-sm-none">
					{visibilityDescription == 'description-visible box-seven' &&
						<OfferDescription 
						visibilityDescription={visibilityDescription}
						setvisibilityDescription={setvisibilityDescription}
						title="Laminaty"
						description="Folie polipropylenowe typu BOPP mogą być stosowane bezpośrednio jako materiał opakowaniowy bądź też jako części składowe laminatów. Folie transparentne – dwuosiowo orientowane, dwustronnie zgrzewalne, jedno- lub dwustronnie przygotowane do druku, o grubości od 20 do 50 mikronów, wykorzystywane przede wszystkim jako monofolie lub części składowe laminatów do pakowania miedzy innymi wyrobów wyrobów spożywczych."
						subTitleOne="Folie mono:"
						subDescriptionOne="<ul><li>folie polipropylenowe BOPP</li><li>folie polietylenowe LDPE</li><li>folie poliestrowe PET</li></ul>"
						subTitleTwo="Laminaty (Duplex)"
						subDescriptionTwo="<ul><li>OPP/OPP</li><li>PET/OPP</li><li>PE/PE</li><li>PET/PE</li><li>PET/PETMET</li><li>OPP/PE</li><li>CPP/PE</li><li>CPP/OPP</li><li>PET/PE EVOH</li></ul><br><br>Folia CPP 5-warstwową nieorientowaną folią polipropylenową. Folia cast wykazuje wysoki stopień elastyczności, miękkości a także wysoką wytrzymałość na rozdarcie i przebicie. Charakteryzuje ją też duża stabilność termiczna i bardzo duża wytrzymałość zgrzewu.
							Doskonale nadaje się do produkcji woreczków do chleba, warzyw, owoców i tekstyliów. Bardzo korzystną właściwością folii jest możliwość tworzenia laminatów z innymi foliami. Odpowiedni dobór właściwości poszczególnych warstw laminatu pozwala na optymalny dobór jego finalnej barierowości lub wytrzymałości mechanicznej potrzebnej do pakowania danego produktu."
						photo1="photos/laminat1.jpg"
						/>
					}
				</div>
				<div className="offers__item" onClick={() => setvisibilityDescription('description-visible box-eight')}>
					<div className="offers__item--content">
						<img className="offer__icon" src="icons/icon_5_c.svg" alt="" />
						<span>Torby foliowe</span>
						<FaAngleDown  className="offers__arrow"/>
					</div>
				</div>
				<div className="d-sm-none">
					{visibilityDescription == 'description-visible box-eight' &&
						<OfferDescription 
						visibilityDescription={visibilityDescription}
						setvisibilityDescription={setvisibilityDescription}
						title="Torby foliowe"
						description="Wykonujemy torby reklamowe z nadrukiem indywidualnym. Obok funkcji czysto użytkowych dzięki umieszczeniu logo zapewniają one znakomitą promocję Państwa Firmy. Torby wykonane są z folii o specjalnie opracowanej recepturze podwyższającej ich wytrzymałość."
						subTitleOne="SPECYFIKACJA:"
						subDescriptionOne="<ul><li>folia: torba z folii HDPE</li><li>opis produktu: torba w kształcie koszulki; zakładki boczne dodatkowo wzmacniają i zwiększają otwór torby,</li><li>kolor: standardowo w kolorze białym, inne kolory pod indywidualne zamówienia – istnieje możliwość zmiany koloru torby poprzez nadruk dowolnego koloru (wg Pantone)</li><li>wytrzymałość: od 7 do 10 kg – w zależności od rozmiaru i uchwytu,</li></ul>"
						photo1="photos/reklamowka.gif"
						/>
					}
				</div>
			</section>
			<div className="d-none d-sm-block">
				{visibilityDescription == 'description-visible box-five' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Torebki foliowe"
					description="W naszej ofercie produkcyjnej znajdziecie Państwo torebki wykonane z wysokiej jakości folii polipropylenowej typu PP CAST oraz LDPE. Charakteryzują się one wysoką przejrzystością i doskonałą przepuszczalnością pary wodnej.<br><br>Cechy te gwarantują najlepsze wyeksponowanie pieczywa oraz optymalizację procesu przechowywania na wszystkich etapach od produkcji przez transport do ekspozycji w sklepach. Umożliwia to skuteczne budowanie korzystnego wizerunku firmy oraz obniżenie ilości zwrotów niesprzedanego pieczywa.<br><br>Oferujemy wykonanie projektów na zamówienie klienta, opartego na dużej gamie gotowych wzorów lub wzoru wykonanego pod zamówienie klienta. Realizujemy zamówienia już od 50 tys. sztuk z terminem dostawy do 3 tygodni od dnia zatwierdzenia wzoru projektu nadruku.<br><br>"
					subTitleOne="NAJWAŻNIEJSZE ZALETY NASZYCH WORECZKÓW:"
					subDescriptionOne="<ul><li>projekt w cenie torebki,</li><li>nadruk fleksograficzny do 8 kolorów</li><li>wysoka wydajność pakowania; fałdy zwiększające pojemność torebki,</li><li>wysoka przejrzystość folii podnosząca estetykę zapakowanego pieczywa,</li><li>otwory wentylacyjne umożliwia pakowanie niestudzonego pieczywa.</li><li>perforacja klapki zwiększa estetykę zapakowanego pieczywa.</li></ul><br><br>"
					photo1="photos/pp1.jpg"
					photo2="photos/pp2.jpg"
					photo3="photos/pp3.jpg"
					photo4="photos/pp4.jpg"
					photopp1="pp/pp1.png"
					photopp2="pp/pp2.png"
					photopp3="pp/pp3.png"
					photopp4="pp/pp4.png"
					photopp5="pp/pp5.png"
					/>
				}
				{visibilityDescription == 'description-visible box-six' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Torebki płaskofałdowe BOPP"
					description="Oferujemy Państwu usługi z zakresu nadruku fleksograficznego do 8 kolorów na folii BOPP. Drukujemy na awersie lub rewersie w zależności od potrzeb. Docinamy i przewijamy folię wg specyfikacji klienta. Zapewniamy kompleksową obsługę od fazy projektu do gotowego opakowania. Oferujemy również fachowe doradztwo i pomoc w redukcji kosztów w trakcie wdrażania nowych oraz już funkcjonujących projektów."
					photo1="photos/BOPP.jpg"
					/>
				}
				{visibilityDescription == 'description-visible box-seven' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Laminaty"
					description="Folie polipropylenowe typu BOPP mogą być stosowane bezpośrednio jako materiał opakowaniowy bądź też jako części składowe laminatów. Folie transparentne – dwuosiowo orientowane, dwustronnie zgrzewalne, jedno- lub dwustronnie przygotowane do druku, o grubości od 20 do 50 mikronów, wykorzystywane przede wszystkim jako monofolie lub części składowe laminatów do pakowania miedzy innymi wyrobów wyrobów spożywczych."
					subTitleOne="Folie mono:"
					subDescriptionOne="<ul><li>folie polipropylenowe BOPP</li><li>folie polietylenowe LDPE</li><li>folie poliestrowe PET</li></ul>"
					subTitleTwo="Laminaty (Duplex)"
					subDescriptionTwo="<ul><li>OPP/OPP</li><li>PET/OPP</li><li>PE/PE</li><li>PET/PE</li><li>PET/PETMET</li><li>OPP/PE</li><li>CPP/PE</li><li>CPP/OPP</li><li>PET/PE EVOH</li></ul><br><br>Folia CPP 5-warstwową nieorientowaną folią polipropylenową. Folia cast wykazuje wysoki stopień elastyczności, miękkości a także wysoką wytrzymałość na rozdarcie i przebicie. Charakteryzuje ją też duża stabilność termiczna i bardzo duża wytrzymałość zgrzewu.
						Doskonale nadaje się do produkcji woreczków do chleba, warzyw, owoców i tekstyliów. Bardzo korzystną właściwością folii jest możliwość tworzenia laminatów z innymi foliami. Odpowiedni dobór właściwości poszczególnych warstw laminatu pozwala na optymalny dobór jego finalnej barierowości lub wytrzymałości mechanicznej potrzebnej do pakowania danego produktu."
					photo1="photos/laminat1.jpg"
					/>
				}
				{visibilityDescription == 'description-visible box-eight' &&
					<OfferDescription 
					visibilityDescription={visibilityDescription}
					setvisibilityDescription={setvisibilityDescription}
					title="Torby foliowe"
					description="Wykonujemy torby reklamowe z nadrukiem indywidualnym. Obok funkcji czysto użytkowych dzięki umieszczeniu logo zapewniają one znakomitą promocję Państwa Firmy. Torby wykonane są z folii o specjalnie opracowanej recepturze podwyższającej ich wytrzymałość."
					subTitleOne="SPECYFIKACJA:"
					subDescriptionOne="<ul><li>folia: torba z folii HDPE</li><li>opis produktu: torba w kształcie koszulki; zakładki boczne dodatkowo wzmacniają i zwiększają otwór torby,</li><li>kolor: standardowo w kolorze białym, inne kolory pod indywidualne zamówienia – istnieje możliwość zmiany koloru torby poprzez nadruk dowolnego koloru (wg Pantone)</li><li>wytrzymałość: od 7 do 10 kg – w zależności od rozmiaru i uchwytu,</li></ul>"
					photo1="photos/reklamowka.gif"
					/>
				}
			</div>
	</Container>
)};

export default Offers;
